import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/shipment/package'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class PackageApi {


    static async getAll({ data = undefined, ...params }) {
        return await fetchService({ url: '/getpackagemethods', method: 'GET', data, notify: { success: false }, ...params })
    }

    static async add({ data = { method: undefined, pay: undefined }, ...params }) {
        return await fetchService({ url: '/addpackagemethod', method: 'POST', data, ...params })
    }

    static async delete({ data = { method: undefined }, ...params }) {
        return await fetchService({ url: '/deletepackagemethod', method: 'DELETE', data, ...params })
    }

    static async changePackageMethod({ data = { method: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changepackagemethod', method: 'PATCH', data, ...params })
    }

}